export default __webpack_public_path__ + "ae2a3f81b594168de92d373fe4bfe5d9.mtl";